import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import StyleOneSectionTitle from './StyleOneSectionTitle'
import StyleOneMustContent from './StyleOneMustContent'

export class StyleOneMustData extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    tabsList: {},
    defaultIndex: 1
  }
  componentWillMount() {
    this.setState({ tabsList: this.props.itemsData });
  }

  toggleTabs(id) {
    let { tabsList } = this.state;
    tabsList.list.map(item => {
      if (item.id === id) {
        item.active = true;
      } else {
        item.active = false;
      }
    })
    this.setState({ tabsList, defaultIndex: id });
  }

  render() {
    let { tabsList, defaultIndex } = this.state;
    return (
      <div className="topic-style-one-must-data">
        <div className='must_data_container'>
          <a name={tabsList.name}><StyleOneSectionTitle Data={tabsList} isColorW={false} /></a>
          <div className='system_section'>
            <div className='system_list'>
              <StyleOneMustContent Data={tabsList.list[defaultIndex - 1]} />
            </div>
            <div className='system_tabs'>
              {tabsList.list && tabsList.list.map(item => <div className={item.active ? 'tabs_item active' : 'tabs_item'} key={item.id} onClick={this.toggleTabs.bind(this, item.id)}>
                {item.title}
              </div>)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleOneMustData);



// WEBPACK FOOTER //
// ./src/features/style-one/StyleOneMustData.js